import { PersonType } from '@/types/api';
import * as Styles from './UserSuggestions.styles';
import AssignableItem from '../AssignableUser';

export type UserType = Pick<PersonType, 'firstName' | 'lastName' | 'pictureUrl' | 'id'>;

type UserSuggestionsType = {
  suggestions?: UserType[];
  onSelectItem: (id: string) => void;
};

export default function UserSuggestionsComponent({
  onSelectItem,
  suggestions,
  ...props
}: UserSuggestionsType): JSX.Element {
  return (
    <Styles.Box {...props} data-testid="user-suggestions">
      <Styles.Subtitle data-testid="user-suggestions-subtitle">Suggestions</Styles.Subtitle>
      {!!suggestions?.length && (
        <div data-testid="user-suggestions-list">
          <ul>
            {suggestions.map((suggestion, index) => {
              return (
                <Styles.SuggestedUserItem key={index.toString()}>
                  <AssignableItem
                    id={suggestion.id}
                    pictureUrl={suggestion.pictureUrl ?? ''}
                    onAssign={() => onSelectItem(suggestion.id)}
                    firstName={suggestion.firstName}
                    lastName={suggestion.lastName}
                  />
                </Styles.SuggestedUserItem>
              );
            })}
          </ul>
        </div>
      )}
    </Styles.Box>
  );
}
